import React from "react"
import { AccordionPanel, Box, Heading } from "@chakra-ui/react"

import { useConfigContext } from "@app/providers/config"
import { useRoutes } from "@app/hooks/useRoutes"
import Row from "@app/components/Migrated/Row"
import Column from "@app/components/Migrated/Column"
import ResolvedContent from "@app/components/ResolvedContent"
import Link from "@app/components/Link"
import ResolvedImage from "@app/components/ResolvedImage"

type Props = {
  item: GatsbyTypes.SanityAccordion["accordionItems"]
}

const AccordionGroupKeyIngredientsItem: React.FC<Props> = ({ item }) => {
  const { urlResolver } = useRoutes()
  const {
    settings: { routes },
  } = useConfigContext()

  return (
    <AccordionPanel p={0}>
      <Row display="flex" justifyContent="space-between" flexWrap="wrap" mt={{ base: "20px", sm: "40px" }}>
        <Column w={{ base: "100%", sm: "31.35%" }}>
          <Box pr={{ sm: "80px" }}>
            <ResolvedContent content={item?.content} sx={{ p: { fontSize: 15, lineHeight: "23px" } }} />
          </Box>
        </Column>
        <Column w={{ base: "100%", sm: "62.5%" }}>
          <Row display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap">
            {item?.ingredients?.map((ingredient, index) => (
              <Column
                key={index}
                mt="20px"
                mb={{ base: "40px", sm: "60px" }}
                textAlign={{ base: "center", sm: "left" }}
                w={{ base: "100%", sm: "43.75%" }}
              >
                <Link to={urlResolver(ingredient, routes.INGREDIENTS)?.url} _hover={{ textDecoration: "none" }}>
                  <ResolvedImage
                    image={ingredient?.image}
                    pos="relative"
                    mx={{ base: "auto", sm: "unset" }}
                    mb={{ sm: "40px" }}
                    borderRadius="50%"
                    w={{ base: "220px", sm: "150px" }}
                    h={{ base: "220px", sm: "150px" }}
                  />
                  <Heading variant="heading26" fontWeight={500} mt="20px" mb={{ base: "20px", sm: "30px" }}>
                    {ingredient?.title}
                  </Heading>
                  <Box>
                    <ResolvedContent content={ingredient?.description} />
                  </Box>
                </Link>
              </Column>
            ))}
          </Row>
        </Column>
      </Row>
    </AccordionPanel>
  )
}

export default React.memo(AccordionGroupKeyIngredientsItem)
